import type { PermissionCode } from "@koclukpanel/authz";
import { GenelBakis } from "./GenelBakis";
import { IslemGecmisi } from "./IslemGecmisi";
import { OgrencileriSekmesi } from "./OgrencileriSekmesi";
import { YukTablosu } from "./YukTablosu";

/**
 * PERSONEL 360° SEKME KAYIT DEFTERİ
 *
 * ================================================================
 * BU EKRAN BİR YETKİ YÜZEYİ — VE ÖĞRENCİDEKİNDEN DAHA KESKİN
 * ================================================================
 * `ogrenci360/sekmeler.tsx` başlığındaki uyarı burada daha da geçerli:
 * personel verisi bugüne kadar ayrı ekranlara dağıldığı için **kazayla**
 * korunuyordu. Tek yere toplanınca o kaza koruma kalkıyor.
 *
 * Personel tarafında ayrıca ikinci bir katman var: bir kişiyi
 * görebilmek, o kişinin ÖĞRENCİLERİNİ görebilmek demek değil. Bu yüzden
 * "Öğrencileri" sekmesi `kisi.ogrenci.goruntule` istiyor ve sunucu da
 * öğrenci kapsam süzgecini AYRICA uyguluyor — sekme süzgeci bir kolaylık,
 * koruma değil.
 *
 * ================================================================
 * SÜZGEÇ KORUMA DEĞİL
 * ================================================================
 * Menüyü ya da sekmeyi gizlemek veriyi korumaz: adresi bilen istek
 * atar. Koruma her ucun kendi izninde ve kendi kapsam kontrolünde.
 * Buradaki süzmenin amacı, kullanıcıya açamayacağı bir sekme
 * göstermemek.
 */
export interface PersonelSekmeProps {
  personelId: string;
  personelAdi: string;
  izinVar: (kod: PermissionCode) => boolean;
}

export interface PersonelSekmesi {
  /** Adres çubuğuna ve `id` üretimine giren kararlı anahtar */
  anahtar: string;
  etiket: string;
  /**
   * Sekmeyi görmek için gereken izinlerden EN AZ BİRİ.
   *
   * Tip "en az bir eleman" diyor: boş dizi derlenmiyor, yani izinsiz
   * bir sekme yazmak mümkün değil.
   */
  izin: readonly [PermissionCode, ...PermissionCode[]];
  Icerik: (props: PersonelSekmeProps) => React.ReactElement;
}

export const PERSONEL_SEKMELERI: readonly PersonelSekmesi[] = [
  {
    anahtar: "genel-bakis",
    etiket: "Genel Bakış",
    izin: ["kisi.personel.goruntule"],
    Icerik: ({ personelId }) => <GenelBakis personelId={personelId} />,
  },
  {
    anahtar: "yuk",
    etiket: "Yük ve Kapasite",
    /*
      GÖRÜNTÜLEME izni yetiyor, YÖNETME değil. Atama kararını veren
      koordinatörün personeli düzenleme yetkisi olmayabilir; tabloyu
      yönetme iznine bağlasaydık, tam da tabloya bakması gereken kişi
      onu göremezdi (F-PPL-12: "atama yapılırken bu tablo gösterilir").
    */
    izin: ["kisi.personel.goruntule"],
    Icerik: ({ personelId }) => <YukTablosu personelId={personelId} />,
  },
  {
    anahtar: "ogrencileri",
    etiket: "Öğrencileri",
    /*
      ÖĞRENCİ İZNİ, PERSONEL İZNİ DEĞİL. Bir uzmanı görebilen ama
      öğrencilerini görmemesi gereken bir rol (yalnızca personel
      kaydına bakan İK gibi) bu sekmeyi görmemeli — ve görse bile
      sunucu boş liste döndürüyor.
    */
    izin: ["kisi.ogrenci.goruntule"],
    Icerik: ({ personelId, personelAdi }) => (
      <OgrencileriSekmesi personelId={personelId} personelAdi={personelAdi} />
    ),
  },
  {
    anahtar: "islem-gecmisi",
    etiket: "İşlem Geçmişi",
    /*
      DENETİM İZNİ, PERSONEL İZNİ DEĞİL. Bir kişiyi görebilmek, onun
      ne yaptığını görebilmek demek değil — ikisi ayrı sorular ve ayrı
      izinler. Sekme mevcut `POST /denetim/etkinlik/kisi` ucunu
      çağırıyor: yeni bir erişim yolu açılmadı, o uç zaten gerekçe
      istiyor ve açılışın kendisini senkron bir güvenlik olayı olarak
      yazıyor.
    */
    izin: ["denetim.etkinlik.kisi"],
    Icerik: ({ personelId, personelAdi }) => (
      <IslemGecmisi personelId={personelId} personelAdi={personelAdi} />
    ),
  },
];
